import { useMemo } from 'react';
import useOnboardingContextValue from 'pages/Onboarding/Onboarding-useOnboardingContextValue';

import { getLabels, getButtonWidth } from './NextButton-functions';

const ContainerComponent = ({ children }) => {
  const {
    currentStepIndex = 0,
    steps,
    handleSubmit = () => {},
    nextStep,
  } = useOnboardingContextValue();

  const totalSteps = steps.length;

  const labels = getLabels(currentStepIndex, totalSteps);

  const width = useMemo(
    () => getButtonWidth(currentStepIndex, totalSteps),
    [currentStepIndex, totalSteps],
  );

  const onClick = () => {
    if (currentStepIndex < steps.length - 1) {
      nextStep();
      return;
    }
    handleSubmit({});
  };

  return children({
    width,
    onClick,
    labels,
  });
};

ContainerComponent.displayName = 'NextButton-container';

export default ContainerComponent;
